export const LOCAL = 'local';
export const DEVELOPMENT = 'dev';
export const STAGING = 'staging';
export const PRODUCTION = 'prod';
export type Environment = typeof LOCAL | typeof DEVELOPMENT | typeof STAGING | typeof PRODUCTION | undefined;
